import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface FooterStyles {
    page?: MobiusPageProps;
    topWrapper?: InjectableCss;
    bottomWrapper?: InjectableCss;
}

export const footerStyles: FooterStyles = {
    page: {
        padding: 20,
    },
};
const styles = footerStyles;

const Footer = ({ id }: PageProps) => (
    <Page as="footer" isFooter={true} {...styles.page}>
        <StyledWrapper {...styles.topWrapper}>
            <Zone contentId={id} zoneName="Content" />
        </StyledWrapper>
        <StyledWrapper {...styles.bottomWrapper}>
            <Zone contentId={id} zoneName="BottomContent" />
        </StyledWrapper>
    </Page>
);

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";
